




















import { Component, Vue, Prop } from 'vue-property-decorator';
import { Endpoints } from '@/ts/store/Constants';
import DocumentsData from '@/ts/DocumentsData';
import pdfvuer from 'pdfvuer';
import axios from 'axios';

@Component({
    components: {
        pdfvuer,
    },
})
export default class DocumentReader extends Vue {
    @Prop() public item!: DocumentsData;

    public page: number = 1;
    public numPages: number = 0;
    public pdfErrors: any[] = [];
    public scale: any = 'page-width';
    public pdfScale: number = 1.0;
    public formattedZoom: string = '100';
    public pdfdata: any;

    public previousScale: number;

    public downloadedPdf: any;
    public pdfLoaded: boolean = false;
    public pdfLoading: boolean = false;

    constructor() {
        super();
    }

    get dataLoaded() {
        if (this.item && this.item !== null && this.pdfLoaded === false && this.pdfLoading === false) {
            this.pdfLoading = true;

            axios.get(Endpoints.Documents.DOCUMENT_DOWNLOAD_PDF(this.item.id), { responseType: 'blob' })
                .then((response) => {
                    let reader = new FileReader();

                    reader.addEventListener('loadend', () => {
                        const array = new Uint8Array((reader.result as ArrayBuffer));

                        this.downloadedPdf = array;
                        this.getPdf();

                        reader = null;
                    });

                    reader.readAsArrayBuffer(response.data);
                });
        }

        return (this.item && this.item !== null);
    }

    public mounted() {
        const blah = this.dataLoaded;
    }

    public getPdf() {
        this.pdfdata = pdfvuer.createLoadingTask({data: this.downloadedPdf});

        this.pdfdata.then((pdf: any) => {
            this.numPages = pdf.numPages;

            this.pdfLoaded = true;
            this.pdfLoading = false;
        });
    }

    get previewData() {
        if (!this.dataLoaded) {
            return null;
        }

        return this.$store.getters['Images/getDocumentPreview'](this.item.id);
    }

    public findPos(obj: any) {
        return obj.offsetTop;
    }

    public onPinchStart(event: any) {
        this.previousScale = this.scale;
    }

    public onPinch(event: any) {
        this.scale = this.previousScale * event.scale;
    }

    public zoomIn() {
        this.scale += 0.1;
    }

    public zoomOut() {
        this.scale -= 0.1;
    }
}
